const Act2019 = [
  {
    path: "/activity190622/perfectinfo",
    name: "perfectinfo",
    component: () => import("@/act2019/activity190622/Perfectinfo.vue"),
    meta: {
      title: "会议活动中心",
    },
  },
  {
    path: "/activity190622/index-back",
    name: "index190622",
    component: () => import("@/act2019/activity190622/Index4"),
    // component: () => import('@/act2019/activity190622/Index'),
    meta: {
      title: "会议活动中心",
    },
  },
  {
    path: "/activity190622/join",
    name: "join",
    component: () => import("@/act2019/activity190622/Join"),
    meta: {
      title: "会议活动中心",
    },
  },
  {
    path: "/thirdparty190711/index",
    name: "index190711",
    component: () => import("@/act2019/thirdparty190711/Index"),
    meta: {
      title: "商务活动调查问卷",
    },
  },

  {
    path: "/oneself190711/index",
    name: "index190711-1",
    component: () => import("@/act2019/thirdparty190711-oneself/Index"),
    meta: {
      title: "商务活动调查问卷",
    },
  },
  {
    path: "/te190806/index",
    name: "index190806",
    component: () => import("@/act2019/te190806/index"),
    meta: {
      title: "TE微信人工客服",
    },
  },
  {
    path: "/adi190806/index",
    name: "index190806adi",
    component: () => import("@/act2019/adi190806/index"),
    meta: {
      title: "ADI提供的汽车电子,工业电子及电路设计的解决方案",
    },
  },
  {
    path: "/tek190717/index",
    name: "index190717",
    component: () => import("@/act2019/tek190717/Index"),
    meta: {
      title: "泰克线下会议",
    },
  },
  {
    path: "/meeting190807/index",
    name: "index190807",
    component: () => import("@/act2019/meeting190807/Index"),
    meta: {
      title: "报名在线研讨会",
    },
  },
  {
    path: "/heilind190812/index",
    name: "index160812",
    component: () => import("@/act2019/heilind190812/Index"),
    meta: {
      title: "赫联调查问卷",
    },
  },
  {
    path: "/dyes/index1",
    name: "dyes1",
    component: () => import("@/act2019/dyes191011/Index1"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index1-1",
    name: "dyes1-1",
    component: () => import("@/act2019/dyes191011/Index1-1"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index2",
    name: "dyes2",
    component: () => import("@/act2019/dyes191011/Index2"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index2-1",
    name: "dyes2-1",
    component: () => import("@/act2019/dyes191011/Index2-1"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index3",
    name: "dyes3",
    component: () => import("@/act2019/dyes191011/Index3"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index3-1",
    name: "dyes3-1",
    component: () => import("@/act2019/dyes191011/Index3-1"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index4",
    name: "dyes4",
    component: () => import("@/act2019/dyes191011/Index4"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index4-1",
    name: "dyes4-1",
    component: () => import("@/act2019/dyes191011/Index4-1"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index5",
    name: "dyes5",
    component: () => import("@/act2019/dyes191011/Index5"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/dyes/index5-1",
    name: "dyes5-1",
    component: () => import("@/act2019/dyes191011/Index5-1"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/GaN/index",
    name: "GaN1",
    component: () => import("@/act2019/gan190808/Index"),
    meta: {
      title: "高效氮化镓，电源设计",
    },
  },
  {
    path: "/meeting190910/index",
    name: "meeting190910",
    component: () => import("@/act2019/meeting190910/Index"),
    meta: {
      title: "报名在线研讨会",
    },
  },

  {
    path: "/vicor190910/index",
    name: "vicor190910",
    component: () => import("@/act2019/vicor190910/Index"),
    meta: {
      title: "vicor活动",
    },
  },
  {
    path: "/wbg190921/index",
    name: "wbg190921",
    component: () => import("@/act2019/wbg190921/Index"),
    meta: {
      title: "宽禁带活动",
    },
  },
  {
    path: "/infineon190925/index",
    name: "infineon190925",
    component: () => import("@/act2019/infineon190925/index"),
    meta: {
      title: "英飞凌小家电",
    },
  },
  {
    path: "/ni190927/index",
    name: "ni190927",
    component: () => import("@/act2019/ni190927/index"),
    meta: {
      title: "ni活动",
    },
  },
  {
    path: "/wbg190930/index/:num",
    name: "wbg190930num",
    component: () => import("@/act2019/wbg190930/index"),
    meta: {
      title: "宽禁带活动",
    },
  },
  {
    path: "/wbg190930/index",
    name: "wbg190930",
    component: () => import("@/act2019/wbg190930/index"),
    meta: {
      title: "宽禁带活动",
    },
  },
  {
    path: "/ni191018/index",
    name: "ni191018",
    component: () => import("@/act2019/ni191018/index"),
    meta: {
      title: "ni活动",
    },
  },
  {
    path: "/heilind191018/index",
    name: "heilind191018",
    component: () => import("@/act2019/heilind191018/Index"),
    meta: {
      title: "赫联活动",
    },
  },
  {
    path: "/playBack191021/index",
    name: "playBack191021",
    component: () => import("@/act2019/playBack191021/Index"),
    meta: {
      title: "回放活动",
    },
  },
  {
    path: "/liveforecast191022/index",
    name: "liveforecast191022",
    component: () => import("@/act2019/liveforecast191022/index"),
    meta: {
      title: "报名直播赢精美礼品",
    },
  },
  {
    path: "/mps191024/index",
    name: "mps191024",
    component: () => import("@/act2019/mps191024/index"),
    meta: {
      title: "MPS-SCRM活动",
    },
  },
  {
    path: "/keysight191101/index",
    name: "keysight191101",
    component: () => import("@/act2019/keysight191101/index"),
    meta: {
      title: "Keysight-SCRM活动",
    },
  },
  // {
  //   path: '/dahua191101/index',
  //   name: 'dahua191101',
  //   component: () => import('@/act2019/dahua191101/index'),
  //   meta: {
  //     title: '大华-SCRM活动'
  //   }
  // },
  {
    path: "/mornsun191031/index",
    name: "mornsun191031",
    component: () => import("@/act2019/mornsun191031/index"),
    meta: {
      title: "金升阳活动",
    },
  },
  {
    path: "/oneself191101/index",
    name: "oneself191101",
    component: () => import("@/act2019/oneself191101/index"),
    meta: {
      title: "商务活动调查问卷",
    },
  },
  {
    path: "/mps191107/index",
    name: "mps191107",
    component: () => import("@/act2019/mps191107/index"),
    meta: {
      title: "活动中心", // MPS线下会议-SCRM
    },
  },
  {
    path: "/artesyn/index",
    name: "artesyn191108",
    component: () => import("@/act2019/artesyn191108/index"),
    meta: {
      title: "活动中心", // 雅特生线下会议-SCRM
    },
  },
  {
    path: "/keysight20191111/index",
    name: "keysight20191111",
    component: () => import("@/act2019/keysight191111/index"),
    meta: {
      title: "是徳活动",
    },
  },
  {
    path: "/meeting191114/index",
    name: "meeting191114",
    component: () => import("@/act2019/meeting191114/index"),
    meta: {
      title: "报名在线研讨会",
    },
  },
  {
    path: "/meetingppt191122/index",
    name: "meetingppt191122",
    component: () => import("@/act2019/meetingppt191122/index"),
    meta: {
      title: "活动中心", // 线下会议PPT下载-SCRM
    },
  },
  {
    path: "/mps191203/index",
    name: "mps191203",
    component: () => import("@/act2019/mps191203/index"),
    meta: {
      title: "活动中心", // 线下会议PPT下载-SCRM
    },
  },
  {
    path: "/taojian191209/index",
    name: "taojian191209",
    component: () => import("@/act2019/taojian191209/index"),
    meta: {
      title: "一起DIY双管正激电源",
    },
  },
  {
    path: "/mps191216/index",
    name: "mps191216",
    component: () => import("@/act2019/mps191216/index"),
    meta: {
      title: "活动中心", // MPS五场直播回放-SCRM
    },
  },
  {
    path: "/mps191226/index",
    name: "mps191226",
    component: () => import("@/act2019/mps191226/index"),
    meta: {
      title: "活动中心", // mps线下会议PPT下载-SCRM
    },
  },
];

export default Act2019;
